// Tekst do porównań w wyszukiwarkach: małe litery i bez znaków diakrytycznych, żeby „narty
// zjazdowe” znajdowało się po „zjazd”, a „Łyżwy” po „lyzwy”. „ł” nie rozkłada się w NFD na
// literę i znak, więc ma osobną zamianę.

export function foldText(s) {
  return String(s ?? '')
    .toLocaleLowerCase('pl')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ł/g, 'l');
}
